import get from 'lodash/get';

import { DEFAULT_ACCOUNT, NoDetailValue } from './constants';

export const compareScenarioDetail = (a, b) => a.detailId === b.detailId;

export const createScenarioDetail = ({ companyCode, countryTaxType }) =>
  () => ({
    companyCode,
    countryTaxType,
    detailName: '',
    value: '',
    account: DEFAULT_ACCOUNT,
  });

export const getDetailsSum = (api, fieldName) => {
  let sum = 0;
  api.forEachNode(node => {
    const value = get(node.data, fieldName);
    if (value !== NoDetailValue && value) {
      sum += value;
    }
  });

  return sum;
};
